import { CometChatTextFormatter } from '@cometchat/chat-uikit-react';
import { marked } from 'marked';

import '../../styles/CometChatMessages/CustomMarkdownFormatter.css';

const markdownPatterns: RegExp[] = [
  // 标题 (#, ##, ..., ######)
  /^#{1,6}\s/m,

  // 粗体 (**...** 或 __...__)
  /\*\*.*?\*\*/,
  /__.*?__/,

  // 斜体 (*...* 或 _..._)
  /\*.*?\*/,
  /_.*?_/,

  // 链接 ([文本](url))
  /\[.*?\]\(.*?\)/,

  // 图片 (![描述](url))
  /!\[.*?\]\(.*?\)/,

  // 无序列表 (- 或 * 或 + 开头)
  /^[-*+]\s/m,

  // 有序列表 (数字. 开头)
  /^\d+\.\s/m,

  // 代码块 (``` 或 `...`)
  /```/,
  /`.*?`/,

  // 引用 (> 开头)
  /^>\s/m,

  // 水平线 (至少3个 - 或 * 或 _)
  /^[-*_]{3,}$/m,

  // 表格 (| 分隔符和表头分隔线)
  /\|.*?\|.*?\|/,
  /^[|:-]+\|/m,

  //  strikethrough (~~...~~)
  /~~.*?~~/,
];

function isMarkdown(text: string): boolean {
  // 只要匹配到任何一种Markdown模式，就认为可能是Markdown文本
  return markdownPatterns.some((pattern) => pattern.test(text));
}

function customizeMarkedRenderer () {
  const renderer = new marked.Renderer();

  // Add target="_blank" to all links
  renderer.link = function(...args) {
    const link = marked.Renderer.prototype.link.apply(this, args);
    return link.replace("<a","<a target='_blank'");
  };

  marked.setOptions({
    renderer: renderer
  });
}

export class CustomMarkdownFormatter extends CometChatTextFormatter {
  constructor() {
    super();

    customizeMarkedRenderer();

    this.setTrackingCharacter('');
    this.setRegexPatterns(markdownPatterns);
  }

  getFormattedText(text: string): string {
    if (!isMarkdown(text) || !text) {
      return text
    }

    return marked.parse(text, {
      async: false,
      gfm: true,
    });
  }

  formatText() {
    const inputValue =
      this.inputElementReference?.innerText ||
      this.inputElementReference?.textContent ||
      '';
    const formattedText = this.getFormattedText(inputValue);
    // Update the composer with formatted text
    if (this.inputElementReference) {
      this.inputElementReference.innerHTML = formattedText || '';
      // Trigger re-render of the composer
      this.reRender();
    }
  }
}
